// import { MsAdalAngular6Service } from 'microsoft-adal-angular6'; // Deprecated - using MSAL v3 instead
import { TAModel } from './../../model/TA.model';
import { AdminService } from './../../services/admin.service';
import { AppConstant } from 'src/app/config/app.constant';
import { AppStateProvider } from './../../services/app-state.provider';
import {
  AfterViewInit,
  Component,
  DoCheck,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  ViewChild,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Location } from '@angular/common';
import { SidenavService } from 'src/app/services/sidenav.service';
import { filter } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss'],
})
export class SideNavComponent
  implements OnInit, OnChanges, DoCheck, AfterViewInit {
  @Input() item: any;
  allSideNav: any = [];
  selectedIndex: any = 0;
  showBookingStatus: boolean = true;
  locationUrl: any;
  selectedMenu: any;
  routerSubscription: any;
  profile: boolean;
  adminData = new TAModel();
  initials: string = '';
  defaultListCount: number = 5;
  seeLess: boolean = true;
  expandVMS: boolean = false;
  expandLandscaping: boolean = false;
  expandCreateandView: boolean = false;
  expandUsers: boolean = false;
  // sideNav1: any[] = [];
  // sideNav2: any[] = [];
  userType = localStorage.getItem('userType');
  subIndex: any;
  mySubscription: any;
  overviewReload = localStorage.getItem('overviewReload') == null ? 'false' : 'true';
  viewMoreButton = localStorage.getItem('seeLess') === 'true' ? true : false;
  @ViewChild('viewMore', { static: false }) viewMore: ElementRef;

  constructor(
    public router: Router,
    private location: Location,
    private appStateSrv: AppStateProvider,
    private adminSrv: AdminService,
    // private adalSrv: MsAdalAngular6Service,
    private sideNavService: SidenavService,
  ) {
    // this.reloadComp()
    // console.log('localStorage.getItem', localStorage.getItem('seeLess'));
    router.events.subscribe((val) => {
      this.locationUrl = location.path();

      /* if (localStorage.getItem('seeLess') === 'true') {
        console.log('viewMore', this.viewMore);
        this.viewMore.nativeElement.dispatchEvent(new MouseEvent('click'));
      } */
    });

    if (this.item) {
      this.selectNav(this.item, 0);
    }

    this.allSideNav = this.sideNavService.getSideNav();
    this.allSideNav = this.setInitialExpandedState(this.allSideNav);
    // console.log('sidenav', this.allSideNav);
  }

  ngDoCheck() {
    // console.log('run check')
    this.expandVMS = localStorage.getItem('expandNav') === 'true' ? true : false;
    this.expandLandscaping = localStorage.getItem('expandNavLand') === 'true' ? true : false;
    this.expandCreateandView = localStorage.getItem('expandNavCreateview') === 'true' ? true : false;
    // this.expandVMS = localStorage.getItem('expandNav') === 'true' ? true : false;
    // this.expandLandscaping = localStorage.getItem('expandNavLand') === 'true' ? true : false;
    // this.expandUsers = localStorage.getItem('expandNavUser') === 'true' ? true : false;
    // if(localStorage.getItem('seeLess') === 'true') {
    //   console.log('viewMore',this.viewMoreButton)
    //   this.viewMore.nativeElement.dispatchEvent(new MouseEvent('click'));
    // }
    if (this.expandLandscaping === true) {
      this.expandVMS = false;
      localStorage.setItem('expandNav', 'false');
      this.expandCreateandView = false;
      localStorage.setItem('expandNavCreateview', 'false');
      this.expandUsers = false;
      localStorage.setItem('expandNavUser', 'false');
    }
    if (this.expandCreateandView === true) {
      this.expandVMS = false;
      localStorage.setItem('expandNav', 'false');
      this.expandLandscaping = false;
      localStorage.setItem('expandNavLand', 'false');
      this.expandUsers = false;
      localStorage.setItem('expandNavUser', 'false');
    }
    if (this.expandUsers === true) {
      this.expandVMS = false;
      localStorage.setItem('expandNav', 'false');
      this.expandLandscaping = false;
      localStorage.setItem('expandNavLand', 'false');
      this.expandCreateandView = false;
      localStorage.setItem('expandNavCreateview', 'false');
    }
  }

  profileClick() {
    // console.log(this.userType);
    // this.profile = true;
    // this.selectedIndex = '10';
    if (this.userType == 'Bridge+') {
      this.router.navigate(['/profile']);
    }
    if (this.userType == 'Parkite') {
      this.router.navigate(['/profile-parkite']);
    }
  }

  getAdminData() {
    this.adminSrv.getAdminData().subscribe((details) => {
      this.adminData.name = details.adminName;
      this.adminData.emailId = details.adminEmailId;
      this.adminData.mobileNumber = details.phoneNumber;
      this.adminData.alternateEmailId = details.alternateEmailId
        ? details.alternateEmailId
        : '';
      this.adminData.id = details.id;
      this.adminData.image = details.profileUrl;
      this.initials =
        this.adminData.name.split(' ')[0].charAt(0).toUpperCase() +
        '' +
        (this.adminData.name.split(' ')[1] === undefined ||
          this.adminData.name.split(' ')[1] === null
          ? ''
          : this.adminData.name.split(' ')[1].charAt(0).toUpperCase());
      // console.log('initials ', this.initials);
      localStorage.setItem(AppConstant.localStorage.userId, details.id);
      this.allSideNav = this.sideNavService.getSideNav();
    });
  }

  getParkiteAdmin() {
    this.adminSrv.getParkiteAdmin().subscribe((details) => {
      // console.log(details);
      localStorage.setItem('isRoleAdmin', details.data.isAdmin);
      localStorage.setItem('hasPriviledge', details.data.isPrivilege);
      // localStorage.setItem('cityId', res.data.cityId);
      // localStorage.setItem('parkTenantId', res.data.parkTenantId);
      this.adminData.name = details.data.adminName;
      this.adminData.emailId = details.data.adminEmailId;
      this.adminData.mobileNumber = details.data.phoneNumber;
      this.adminData.alternateEmailId = details.data.alternateEmailId
        ? details.data.alternateEmailId
        : '';
      this.adminData.id = details.data.id;
      this.adminData.image = details.data.profileUrl;
      this.initials =
        this.adminData.name.split(' ')[0].charAt(0).toUpperCase() +
        '' +
        (this.adminData.name.split(' ')[1] === undefined ||
          this.adminData.name.split(' ')[1] === null
          ? ''
          : this.adminData.name.split(' ')[1].charAt(0).toUpperCase());
      // console.log('initials ', this.initials);
      localStorage.setItem(AppConstant.localStorage.userId, details.data.id);
      this.allSideNav = this.sideNavService.getSideNav();
      // console.log(this.overviewReload);
      if (this.overviewReload === 'false') {
        localStorage.setItem('overviewReload', 'true');
        // window.location.reload();
      }
    });
  }

  ngOnChanges() {
    // console.log('on changes');
  }

  ngOnInit() {
    this.expandVMS = localStorage.getItem('expandNav') === 'true' ? true : false;
    this.expandLandscaping = localStorage.getItem('expandNavLand') === 'true' ? true : false;
    this.expandCreateandView = localStorage.getItem('expandNavCreateview') === 'true' ? true : false;
    // this.expandVMS = localStorage.getItem('expandNav') === 'true' ? true : false;
    // this.expandLandscaping = localStorage.getItem('expandNavLand') === 'true' ? true : false;
    // this.expandUsers = localStorage.getItem('expandNavUser') === 'true' ? true : false;

    if (
      localStorage.getItem(AppConstant.localStorage.token) !== null &&
      localStorage.getItem(AppConstant.localStorage.token) !== 'token' &&
      localStorage.getItem(AppConstant.localStorage.token) !== '' 
      // && this.adalSrv.isAuthenticated
    )
      if (this.userType == 'Bridge+') {
        this.getAdminData();
      } else {
        // New api for parkite
        this.getParkiteAdmin();
      }

    this.appStateSrv.getSetNavState().subscribe((state) => {
      if (state !== undefined) {
        this.item = [state];
        // console.log(this.item);
        if (this.item[0].hasOwnProperty('sub')) {
          this.selectNav(
            this.item,
            // this.item[0]?.sub !== [] ? this.item[0].sub[0].index : 0
            this.item[0]?.sub !== '' ? this.item[0].sub[0].index : 0
          );
        } else {
          this.selectNav(this.item, 0);
        }
      }
    });

    // console.log('seeLess', this.seeLess);
    // localStorage.removeItem('seeLess');

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.updateExpandedState(this.allSideNav, this.router.url);
      });
  }

  ngAfterViewInit() {
    if (localStorage.getItem('seeLess') === 'true') {
      this.viewMore.nativeElement.dispatchEvent(new MouseEvent('click'));
    }
  }

  async selectNav(item, j, status = false) {
    // console.log('j', j);
    // console.log('resssssssss', item);

    if (item && item.length > 0 && !item[0]?.hasOwnProperty('sub')) {
      // console.log('if');
      this.expandVMS = false;
      this.expandLandscaping = false;
      this.expandCreateandView = false;
      this.expandUsers = false;
      this.selectedIndex = item[0].index;
      this.selectedMenu = item[0];
      this.subIndex = j;
      if (item[0].link !== '') this.router.navigate([item[0].link]);
      this.item = [];
    }
    // else if (item[0]?.sub?.length > 0 && item[0]?.sub?.length < 1) {
    //   this.selectedIndex = item[0]?.index;
    //   this.selectedMenu = item[0];
    //   this.subIndex = j;
    //   this.router.navigate([
    //     item[0]?.link == '' ? item[0]?.sub[j].link : item[0]?.link,
    //   ]);
    // }
    // else if (item[0]?.sub?.length > 2) {
    //   this.selectedIndex = item[0]?.index;
    //   this.selectedMenu = item[0];
    //   this.subIndex = j;
    //   this.router.navigate([
    //     item[0]?.link == '' ? item[0]?.sub[j]?.link : item[0]?.link,
    //   ]);
    // }
    else if (status) {
      // console.log('abc');
      // console.log(item.length);
      this.selectedIndex = item?.index;
      // this.selectedMenu = item;
      this.selectedMenu = await this.sideNavService.updateRoutingChunks({
        name: Array.isArray(item) ? item[0].name : item.name,
        subNav: j,
      });
      // console.log('this.selectedMenu', this.selectedMenu);
      this.subIndex = j;
      let navigateLink;
      if (this.selectedMenu.hasOwnProperty('sub')) {
        // console.log(this.selectedMenu);
        navigateLink = this.selectedMenu.sub[0].link;
      } else {
        // console.log(this.selectedMenu);
        navigateLink = this.selectedMenu.link;
      }
      // console.log(navigateLink);
      this.router.navigate([navigateLink]);
      // if (item.length == undefined) {
      //   this.router.navigate([
      //     item.link == '' ? item?.sub[j]?.link : item?.link,
      //   ]);
      // } else {
      //   this.router.navigate([
      //     item[0].link == '' ? item[0]?.sub[j]?.link : item[0]?.link,
      //   ]);
      // }
    } else {
      // console.log('sles console');
      // console.log(item);
      this.selectedIndex = item?.index;
      this.selectedMenu = item;
      this.subIndex = j;
      if (item.length == undefined) {
        this.router.navigate([
          item.link == '' ? item?.sub[j]?.link : item?.link,
        ]);
      } else {
        if (item[0].link) {
          if (item[0].sub[0].hasOwnProperty('queryParam')) {
            // console.log('inside func');
            this.router.navigate(
              [
                item[0].link == ''
                  ? item[0]?.sub[item[0]?.sub.length > 1 ? j : 0]?.link
                  : item[0]?.link,
              ],
              item[0].sub[0].queryParam
            );
          } else {
            this.router.navigate([
              item[0].link == ''
                ? item[0]?.sub[item[0]?.sub.length > 1 ? j : 0]?.link
                : item[0]?.link,
            ]);
          }
        }
      }
    }
  }

  hideShowNav(i) {
    this.toggle('close');
    if (i == 4) {
      this.expandVMS = false;
    }
    if (i == 5) {
      this.expandLandscaping = false;
    }

    if (i == 1) {
      this.expandUsers = false;
    }
  }

  checkActive(link) {
    if (!this.locationUrl) {
      this.locationUrl = this.location.path();
    }
    /* console.log(
      'this.locationUrl.indexOf(link)',
      this.locationUrl.indexOf(link)
    ); */
    if (this.locationUrl && this.locationUrl.indexOf(link) !== -1) {
      return true;
    }
    return false;
  }

  toggle(type) {
    // console.log('toggle');
    this.expandVMS = type == 'close' ? false : !this.expandVMS;
    this.expandLandscaping = type == 'close' ? false : !this.expandLandscaping;
    this.expandCreateandView = type == 'close' ? false : !this.expandCreateandView;
    this.expandUsers = type == 'close' ? false : !this.expandUsers;
  }

  reloadComp() {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    this.mySubscription = this.router.events.subscribe((event) => {
      // console.log('events changes');
      if (event instanceof NavigationEnd) {
        // Trick the Router into believing it's last link wasn't previously loaded
        this.router.navigated = false;
      }
    });
  }

  ngOnDestroy() {
    localStorage.setItem('overviewReload', 'false');
    if (this.mySubscription) {
      this.mySubscription.unsubscribe();
    }
  }

  toggleSubMenu(item: any) {
    if (item.sub && item.sub.length > 0) {
      item.expanded = !item.expanded;

      if (item.expanded) {
        this.openFirstSubmenu(item);
      }
    }
  }

  private setInitialExpandedState(items: any) {
    // Add the "expanded" property to each menu item
    return items.map((item: any) => ({
      ...item,
      expanded: false,
      sub: this.setInitialExpandedState(item.sub || []),
    }));
  }

  private updateExpandedState(items: any, currentUrl: string) {
    items.forEach((item: any) => {
      if (item.link && currentUrl.startsWith(item.link)) {
        item.expanded = true;
      } else if (item.sub) {
        this.updateExpandedState(item.sub, currentUrl);
        item.expanded = item.sub.some((child: any) => child.expanded);
      }
    });
  }

  private openFirstSubmenu(parentItem: any, index?:number) {
    if (!parentItem.sub || index > 0) {
      return;
    }

    const firstSubmenu = parentItem.sub.find((submenu: any) => submenu.link);
    if (firstSubmenu) {
      firstSubmenu.expanded = true;
      this.router.navigate([firstSubmenu.link]);
    } else {
      parentItem.sub.forEach((child: any, index: number) => {
        if (child.sub) {
          this.openFirstSubmenu(child, index);
        }
      });
    }
  }
}
